export const USER_PERMISSIONS = {
  Administrador: [
    "/Administrador",
    "/Preregistro",
    "/SignosVitales",
    "/Triage",
    "/Medico",
    "/TurnosAdminSignos",
    "/TurnosAdminTriage",
    "/turnos",
    "/AdminEstadisticas",
  ],
  Capturista: [
    "/Preregistro",
  ],
  SignosVitales: [
    "/SignosVitales",
  ],
  Triage: [
    "/Triage",
  ],
  Doctor: [
    "/Medico",
  ],
  AdminSignos: [
    "/TurnosAdminSignos",
  ],
  AdminTriage: [
    "/TurnosAdminTriage",
  ],
  AdminEstadisticas: [
    "/AdminEstadisticas",
  ],
};
